import styled from 'styled-components/macro'
import { media } from '../../utils/styles'
import MainWrapper from '../MainWrapper'

const FooterWrapper = styled(MainWrapper)`
  ${media('desktop')`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  `}
`

export default FooterWrapper
